
<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import SettingsQrOrder from "@/components/SettingsQrOrder";

/**
 * Reporting component
 */
export default {
  page: {
    title: "SettingsOrder",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {Layout, SettingsQrOrder},

};
</script>

<template>
  <Layout>

    <div class="px-3">
      <SettingsQrOrder/>
    </div>

  </Layout>
</template>
